import { render } from "./PartnerInfo.vue?vue&type=template&id=1dc2aa52"
import script from "./PartnerInfo.vue?vue&type=script&lang=js"
export * from "./PartnerInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__